module.exports = __webpack_public_path__ + "static/Mark-Stevens-4b70e9e03d904bc9ae59d82918ae96d7.webp";